import { useCallback, useMemo } from "react";
import Particles from "@tsparticles/react";
import { loadSlim } from "@tsparticles/slim";

export const SwarmBackground = () => {
  const particlesInit = useCallback(async (engine) => {
    await loadSlim(engine);
  }, []);

  const options = useMemo(() => ({
    fullScreen: { enable: false },
    background: { color: { value: "transparent" } },
    fpsLimit: 60,
    interactivity: {
      detectOn: "canvas",
      events: {
        onHover: { enable: true, mode: "grab" },
        onClick: { enable: true, mode: "push" },
        resize: true,
      },
      modes: {
        grab: { distance: 140, links: { opacity: 0.5 } },
        push: { quantity: 4 },
      },
    },
    particles: {
      color: { value: ["#8B5CF6", "#06B6D4", "#10B981"] },
      links: {
        color: "#8B5CF6",
        distance: 150,
        enable: true,
        opacity: 0.15,
        width: 1,
      },
      move: {
        direction: "none",
        enable: true,
        outModes: { default: "out" },
        random: true,
        speed: 1.5,
        straight: false,
        attract: { enable: true, rotateX: 600, rotateY: 1200 },
      },
      number: {
        density: { enable: true, area: 900 },
        value: 80,
      },
      opacity: {
        value: { min: 0.2, max: 0.6 },
        animation: { enable: true, speed: 1, minimumValue: 0.1, sync: false },
      },
      shape: { type: "circle" },
      size: {
        value: { min: 1, max: 4 },
        animation: { enable: true, speed: 2, minimumValue: 1, sync: false },
      },
    },
    detectRetina: true,
  }), []);

  return (
    <Particles
      id="swarm-particles"
      init={particlesInit}
      options={options}
      className="absolute inset-0 z-0"
    />
  );
};

export default SwarmBackground;
